export const BACKGROUND_TASK_SETTINGS_MODEL_ID = "backgroundTaskSettings";
export const BACKGROUND_TASK_MAX_RETENTION_DAYS = 3650;
export const BACKGROUND_TASK_DEFAULT_RETENTION_DAYS = 90;
